import { Patient, User } from '../models';
import { STRINGS } from '../i18n/strings';
import { validate as nirValidate } from 'validcq';
import { UseFormMethods } from 'react-hook-form';
// import isoCountryList from '../utils/isoCountryList';

export type FieldProps = {
  label: string;
  name: string;
  type:
    | 'number'
    | 'time'
    | 'text'
    | 'email'
    | 'password'
    | 'tel'
    | 'url'
    | 'search'
    | 'date'
    | 'file'
    | 'select'
    | undefined;
  value?: any;
  placeholder?: string;
  rules?: Object;
  options?: Array<{ label: string; value: any }>;
  disabled?: boolean;
};

export type InputProps = {
  name: string;
  fields: Array<FieldProps>;
};

export type Inputs = {
  firstName: string;
  lastName: string;
  email: string;
  birthdate: Date;
  phone: string;
  nir: string;
  carteVital: File;
  mutuelle: File;
  cmu: File;
  line1: string;
  postcode: string;
  city: string;
  country: string;
  extra: string;
  password: string;
  new_password: string;
  confirm_new_password: string;
};

export function getUserSections(
  patient: Patient,
  user: User,
  hookForm?: UseFormMethods<Inputs>
): Array<InputProps> {
  return [
    {
      name: 'Informations',
      fields: [
        {
          label: 'Prénom',
          name: 'firstName',
          type: 'text',
          value: patient.firstName,
          rules: {
            required: STRINGS.FR.FORM_ERROR_FIELD_REQUIRED
          },
          disabled: true
        },
        {
          label: 'Nom',
          name: 'lastName',
          type: 'text',
          value: patient.lastName,
          rules: {
            required: STRINGS.FR.FORM_ERROR_FIELD_REQUIRED
          },
          disabled: true
        },
        {
          label: 'Nom de naissance',
          name: 'birthName',
          type: 'text',
          value: patient.birthName,
          disabled: true
        },
        {
          label: 'Email (identique pour vous et vos proches)',
          name: 'email',
          type: 'email',
          value: user.email,
          rules: {
            pattern: {
              value:
                /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
              message: STRINGS.FR.FORM_ERROR_FIELD_EMAIL_INCORRECT
            },
            required: STRINGS.FR.FORM_ERROR_FIELD_REQUIRED
          },
          disabled: true
        },
        {
          label: 'Date de naissance',
          name: 'birthdate',
          type: 'date',
          value: patient.birthdate,
          rules: {
            required: STRINGS.FR.FORM_ERROR_FIELD_REQUIRED
          },
          disabled: true
        },
        {
          label: 'Téléphone',
          name: 'phone',
          type: 'tel',
          value: patient.phone,
          rules: {
            required: STRINGS.FR.FORM_ERROR_FIELD_REQUIRED
          }
        },
        {
          label: 'Médecin traitant',
          name: 'referringDoctor',
          type: 'text',
          value: patient.referringDoctor
        }
      ]
    },
    {
      name: 'Documents',
      fields: [
        {
          label: 'N° sécurité sociale',
          name: 'nir',
          type: 'tel',
          value: patient.nir,
          rules: {
            validate: (value: any) => {
              return (
                nirValidate(`${value}`) ||
                STRINGS.FR.FORM_ERROR_FIELD_NIR_INCORRECT
              );
            }
          },
          disabled: true
        },
        {
          label: 'Carte Vitale',
          name: 'insurance',
          type: 'file',
          value: null
        },
        {
          label: 'Mutuelle',
          name: 'mutual',
          type: 'file',
          value: null
        }
      ]
    },
    {
      name: 'Adresse',
      fields: [
        {
          label: 'Adresse',
          name: 'address.line1',
          type: 'text',
          value: patient.address.line1 || '',
          rules: {
            required: STRINGS.FR.FORM_ERROR_FIELD_REQUIRED
          }
        },
        {
          label: 'Code postal',
          name: 'address.postcode',
          type: 'text',
          value: patient.address.postcode || '',
          rules: {
            required: STRINGS.FR.FORM_ERROR_FIELD_REQUIRED
          }
        },
        {
          label: 'Ville',
          name: 'address.city',
          type: 'text',
          value: patient.address.city || '',
          rules: {
            required: STRINGS.FR.FORM_ERROR_FIELD_REQUIRED
          }
        }
        // {
        //   label: 'Pays',
        //   name: 'address.country',
        //   type: 'select',
        //   value: patient.address.country || '',
        //   options: isoCountryList.map((country) => ({
        //     value: country['alpha-2'].toLowerCase(),
        //     label: country.name
        //   })),
        //   rules: {
        //     required: STRINGS.FR.FORM_ERROR_FIELD_REQUIRED
        //   }
        // }
      ]
    }
  ];
}
